export function buildDirectionsUrl(latitude?: number | null, longitude?: number | null): string {
	if (!latitude || !longitude) {
		return '';
	}

	return `https://www.google.com/maps?saddr=My+Location&daddr=${latitude},${longitude}`;
}
